import React from "react"
import { FaCircleExclamation } from "react-icons/fa6"

function NurseAssignment({ formData, setFormData, errors, hasWriteSettingsPermission }) {
	if (hasWriteSettingsPermission) {
		// Editable version
		return (
			<div>
				<h2 className="text-2xl font-semibold text-gray-900 mb-4">
					Nurse Assignment Rules
				</h2>

				{/* Max Patient-Nurse Ratio */}
				<div className="col-span-2 sm:col-span-2 flex items-center mb-6">
					<div className="flex-1">
						<label
							htmlFor="patientNurseRatio"
							className="block text-sm font-medium text-gray-700"
						>
							Max Patient-Nurse Ratio
						</label>
						<div className="flex items-center mt-2">
							<div className="relative flex-1 rounded-md shadow-sm">
								<input
									type="number"
									value={formData?.patientNurseRatio || ""}
									onChange={e =>
										setFormData(prev => ({
											...prev,
											patientNurseRatio: e.target.value
										}))
									}
									className={`block w-full rounded-md border-0 py-1.5 pr-10 text-gray-900 placeholder:text-gray-500 focus:ring-2 focus:ring-inset sm:text-sm sm:leading-6 ${
										errors.patientNurseRatio
											? "text-red-900 ring-1 ring-inset ring-red-300 placeholder:text-red-300 focus:ring-red-500"
											: "ring-1 ring-inset ring-gray-300 focus:ring-indigo-500"
									}`}
									placeholder="Required Patient-Nurse Ratio"
									aria-invalid={errors.patientNurseRatio ? "true" : "false"}
								/>
								{errors.patientNurseRatio && (
									<div className="pointer-events-none absolute right-3 top-1/2 transform -translate-y-1/2 flex items-center">
										<FaCircleExclamation
											aria-hidden="true"
											className="h-5 w-5 text-red-500"
										/>
									</div>
								)}
							</div>
						</div>
						{errors.patientNurseRatio && (
							<p id="patientNurseRatio-error" className="text-red-500 text-sm mt-1">
								{errors.patientNurseRatio}
							</p>
						)}
					</div>
				</div>

				{/* Max Acuity for Center */}
				<div className="col-span-2 sm:col-span-2 flex items-center mb-6">
					<div className="flex-1">
						<label
							htmlFor="maxAcuityForCenter"
							className="block text-sm font-medium text-gray-700"
						>
							Max Acuity for Center
						</label>
						<div className="flex items-center mt-2">
							<div className="relative flex-1 rounded-md shadow-sm">
								<input
									type="number"
									value={formData?.maxAcuityForCenter || ""}
									onChange={e =>
										setFormData(prev => ({
											...prev,
											maxAcuityForCenter: e.target.value
										}))
									}
									className={`block w-full rounded-md border-0 py-1.5 pr-10 text-gray-900 placeholder:text-gray-500 focus:ring-2 focus:ring-inset sm:text-sm sm:leading-6 ${
										errors.maxAcuityForCenter
											? "text-red-900 ring-1 ring-inset ring-red-300 placeholder:text-red-300 focus:ring-red-500"
											: "ring-1 ring-inset ring-gray-300 focus:ring-indigo-500"
									}`}
									placeholder="Max Acuity for Center"
									aria-invalid={errors.maxAcuityForCenter ? "true" : "false"}
								/>
								{errors.maxAcuityForCenter && (
									<div className="pointer-events-none absolute right-3 top-1/2 transform -translate-y-1/2 flex items-center">
										<FaCircleExclamation
											aria-hidden="true"
											className="h-5 w-5 text-red-500"
										/>
									</div>
								)}
							</div>
						</div>
						{errors.maxAcuityForCenter && (
							<p id="maxAcuityForCenter-error" className="text-red-500 text-sm mt-1">
								{errors.maxAcuityForCenter}
							</p>
						)}
					</div>
				</div>

				{/* Max Acuity for Center at Any Time */}
				<div className="col-span-2 sm:col-span-2 flex items-center mb-6">
					<div className="flex-1">
						<label
							htmlFor="maxAcuityForCenterAtAnyTime"
							className="block text-sm font-medium text-gray-700"
						>
							Max Acuity for Center at Any Time
						</label>
						<div className="flex items-center mt-2">
							<div className="relative flex-1 rounded-md shadow-sm">
								<input
									type="number"
									value={formData?.maxAcuityForCenterAtAnyTime || ""}
									onChange={e =>
										setFormData(prev => ({
											...prev,
											maxAcuityForCenterAtAnyTime: e.target.value
										}))
									}
									className={`block w-full rounded-md border-0 py-1.5 pr-10 text-gray-900 placeholder:text-gray-500 focus:ring-2 focus:ring-inset sm:text-sm sm:leading-6 ${
										errors.maxAcuityForCenterAtAnyTime
											? "text-red-900 ring-1 ring-inset ring-red-300 placeholder:text-red-300 focus:ring-red-500"
											: "ring-1 ring-inset ring-gray-300 focus:ring-indigo-500"
									}`}
									placeholder="Max Acuity for Center at Any Time"
									aria-invalid={
										errors.maxAcuityForCenterAtAnyTime ? "true" : "false"
									}
								/>
								{errors.maxAcuityForCenterAtAnyTime && (
									<div className="pointer-events-none absolute right-3 top-1/2 transform -translate-y-1/2 flex items-center">
										<FaCircleExclamation
											aria-hidden="true"
											className="h-5 w-5 text-red-500"
										/>
									</div>
								)}
							</div>
						</div>
						{errors.maxAcuityForCenterAtAnyTime && (
							<p
								id="maxAcuityForCenterAtAnyTime-error"
								className="text-red-500 text-sm mt-1"
							>
								{errors.maxAcuityForCenterAtAnyTime}
							</p>
						)}
					</div>
				</div>

				{/* Max Acuity for Nurse */}
				<div className="col-span-2 sm:col-span-2 flex items-center mb-6">
					<div className="flex-1">
						<label
							htmlFor="maxAcuityForNurse"
							className="block text-sm font-medium text-gray-700"
						>
							Max Acuity for Nurse
						</label>
						<div className="flex items-center mt-2">
							<div className="relative flex-1 rounded-md shadow-sm">
								<input
									type="number"
									value={formData?.maxAcuityForNurse || ""}
									onChange={e =>
										setFormData(prev => ({
											...prev,
											maxAcuityForNurse: e.target.value
										}))
									}
									className={`block w-full rounded-md border-0 py-1.5 pr-10 text-gray-900 placeholder:text-gray-500 focus:ring-2 focus:ring-inset sm:text-sm sm:leading-6 ${
										errors.maxAcuityForNurse
											? "text-red-900 ring-1 ring-inset ring-red-300 placeholder:text-red-300 focus:ring-red-500"
											: "ring-1 ring-inset ring-gray-300 focus:ring-indigo-500"
									}`}
									placeholder="Max Acuity for Nurse"
									aria-invalid={errors.maxAcuityForNurse ? "true" : "false"}
								/>
								{errors.maxAcuityForNurse && (
									<div className="pointer-events-none absolute right-3 top-1/2 transform -translate-y-1/2 flex items-center">
										<FaCircleExclamation
											aria-hidden="true"
											className="h-5 w-5 text-red-500"
										/>
									</div>
								)}
							</div>
						</div>
						{errors.maxAcuityForNurse && (
							<p id="maxAcuityForNurse-error" className="text-red-500 text-sm mt-1">
								{errors.maxAcuityForNurse}
							</p>
						)}
					</div>
				</div>

				{/* Max Acuity for Nurse at Any Time */}
				<div className="col-span-2 sm:col-span-2 flex items-center mb-6">
					<div className="flex-1">
						<label
							htmlFor="maxAcuityForNurseAtAnyTime"
							className="block text-sm font-medium text-gray-700"
						>
							Max Acuity for Nurse at Any Time
						</label>
						<div className="flex items-center mt-2">
							<div className="relative flex-1 rounded-md shadow-sm">
								<input
									type="number"
									value={formData?.maxAcuityForNurseAtAnyTime || ""}
									onChange={e =>
										setFormData(prev => ({
											...prev,
											maxAcuityForNurseAtAnyTime: e.target.value
										}))
									}
									className={`block w-full rounded-md border-0 py-1.5 pr-10 text-gray-900 placeholder:text-gray-500 focus:ring-2 focus:ring-inset sm:text-sm sm:leading-6 ${
										errors.maxAcuityForNurseAtAnyTime
											? "text-red-900 ring-1 ring-inset ring-red-300 placeholder:text-red-300 focus:ring-red-500"
											: "ring-1 ring-inset ring-gray-300 focus:ring-indigo-500"
									}`}
									placeholder="Max Acuity for Nurse at Any Time"
									aria-invalid={
										errors.maxAcuityForNurseAtAnyTime ? "true" : "false"
									}
								/>
								{errors.maxAcuityForNurseAtAnyTime && (
									<div className="pointer-events-none absolute right-3 top-1/2 transform -translate-y-1/2 flex items-center">
										<FaCircleExclamation
											aria-hidden="true"
											className="h-5 w-5 text-red-500"
										/>
									</div>
								)}
							</div>
						</div>
						{errors.maxAcuityForNurseAtAnyTime && (
							<p
								id="maxAcuityForNurseAtAnyTime-error"
								className="text-red-500 text-sm mt-1"
							>
								{errors.maxAcuityForNurseAtAnyTime}
							</p>
						)}
					</div>
				</div>
			</div>
		)
	} else {
		// Read-only version
		return (
			<div>
				<h2 className="text-2xl font-semibold text-gray-900 mb-4">
					Nurse Assignment Rules
				</h2>

				{/* Max Patient-Nurse Ratio */}
				<div className="col-span-2 sm:col-span-2 mb-6">
					<label className="block text-sm font-medium text-gray-700">
						Max Patient-Nurse Ratio
					</label>
					<span className="block w-full rounded-md py-1.5 text-gray-900 sm:text-sm">
						{formData.patientNurseRatio || "N/A"}
					</span>
				</div>

				{/* Max Acuity for Center */}
				<div className="col-span-2 sm:col-span-2 mb-6">
					<label className="block text-sm font-medium text-gray-700">
						Max Acuity for Center
					</label>
					<span className="block w-full rounded-md py-1.5 text-gray-900 sm:text-sm">
						{formData.maxAcuityForCenter || "N/A"}
					</span>
				</div>

				{/* Max Acuity for Center at Any Time */}
				<div className="col-span-2 sm:col-span-2 mb-6">
					<label className="block text-sm font-medium text-gray-700">
						Max Acuity for Center at Any Time
					</label>
					<span className="block w-full rounded-md py-1.5 text-gray-900 sm:text-sm">
						{formData.maxAcuityForCenterAtAnyTime || "N/A"}
					</span>
				</div>

				{/* Max Acuity for Nurse */}
				<div className="col-span-2 sm:col-span-2 mb-6">
					<label className="block text-sm font-medium text-gray-700">
						Max Acuity for Nurse
					</label>
					<span className="block w-full rounded-md py-1.5 text-gray-900 sm:text-sm">
						{formData.maxAcuityForNurse || "N/A"}
					</span>
				</div>

				{/* Max Acuity for Nurse at Any Time */}
				<div className="col-span-2 sm:col-span-2 mb-6">
					<label className="block text-sm font-medium text-gray-700">
						Max Acuity for Nurse at Any Time
					</label>
					<span className="block w-full rounded-md py-1.5 text-gray-900 sm:text-sm">
						{formData.maxAcuityForNurseAtAnyTime || "N/A"}
					</span>
				</div>
			</div>
		)
	}
}

export default NurseAssignment
